import { useState, useEffect } from "react";
import { database } from "../firebase/config";
import { ref, onValue } from "firebase/database";

export const useProgramCategories = (path) => {
    const [programCategories, setProgramCategories] = useState(null)
 
        useEffect(() => {
            const dbRef = ref(database, path);  
            const unsub = onValue(dbRef, (snapshot) => {
                let results = []
                snapshot.forEach((childSnapshot) => {
                    let adminPrograms = []

                    const categoryName = childSnapshot.key // alle -> categoryName
                    childSnapshot.forEach((subSnapshot) => {
                        const programName = subSnapshot.key // 4x4 -> programName
                        const exercises = subSnapshot.val() // exercises
                        adminPrograms.push({id: programName, programName: programName, exercises: exercises})
                    })
                    results.push({id: categoryName, name: categoryName, adminPrograms: adminPrograms})
                })
                setProgramCategories(results)
            }, {
                 onlyOnce: false
            });
          return () => unsub() 
     
         }, [path])
    return { programCategories }
}